/**
 * Parse a backend timestamp safely.
 *
 * The API serializes naive-UTC datetimes without a timezone marker
 * ("2026-09-03T14:30:00"). JavaScript's Date reads marker-less ISO strings as
 * LOCAL time, silently shifting every rendered timestamp by the viewer's UTC
 * offset (the "my message says 2 hours ago when I just sent it" bug, Aleix
 * 9/3). Treat marker-less datetimes as UTC; strings that already carry
 * Z / ±hh:mm (e.g. timestamptz columns) and date-only strings pass through
 * untouched.
 */
export function parseApiDate(value: string | number | Date): Date {
  if (value instanceof Date || typeof value === 'number') return new Date(value);
  const needsUtcMarker =
    value.includes('T') && !/(?:Z|[+-]\d{2}:?\d{2})$/i.test(value);
  return new Date(needsUtcMarker ? `${value}Z` : value);
}
